import React from "react"
import { Link } from "gatsby"
import { Container, Row, Col, Jumbotron, Button } from "react-bootstrap"
import EducationPic from "../images/education_pic.png"
import Industri from "../images/industri.png"
import Communication from "../images/communication.png"
import Collaboration from "../images/collaboration.png"
import Thinking from "../images/thinking.png"
import Creativity from "../images/creativity.png"
import "../styles/default.css"
import "../styles/education.css"
import { useTranslation } from "react-i18next"

const contents = [
  {
    image: Thinking,
    alt: "critical_thinking",
    title: "eThinkingTitle",
    body: "eThinkingBody",
    button: "Explore Timeline",
    link: `/timeline`,
  },
  {
    image: Creativity,
    alt: "creativity",
    title: "eCreativityTitle",
    body: "eCreativityBody",
    button: `Meet Student`,
    link: `/impact#student`,
  },
  {
    image: Communication,
    alt: "communication",
    title: "eCommunicatTitle",
    body: "eCommunicatBody",
    button: `Our Programs`,
    link: `/programs`,
  },
  {
    image: Collaboration,
    alt: `collaboration`,
    title: "eCollabTitle",
    body: "eCollabBody",
    button: "Our Impact",
    link: `/impact`,
  },
]

export default function Education() {
  const { t } = useTranslation()
  return (
    <section className="education-area">
      <div className="education-hero bg-light">
        <div className="education-hero-img">
          <img
            src={EducationPic}
            alt="A girl wearing glass working in an industry"
            loading="lazy"
          />
        </div>
        <div className="hero-shape"></div>
        <Container>
          <Row>
            <Col sm={8} className="education-hero-content">
              <h1 className="title-section" style={{ maxWidth: "30px" }}>
                Why Education
              </h1>
              <h5 className="description-section mt-30">{t("whyEducation")}</h5>
              <p className="text-content mt-15">{t("whyEducationCont")}</p>
            </Col>
          </Row>
        </Container>
      </div>
      <Jumbotron fluid className="education-img bg-light">
        <img src={Industri} alt="Industry 4.0" loading="lazy"></img>
      </Jumbotron>
      <div className="kompetensi-area bg-white">
        <Container>
          <Row>
            <Col lg={8}>
              <div className="kompetensi-content">
                <h1 className="title-section-inside mt-50">
                  {t("competence")}
                </h1>
                <h6 className="sub-title mt-15">The 4 Cs Learning.</h6>
                <p className="text-content mt-30">{t("learning")}</p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="kompetensi-item bg-light">
        <Container>
          <Row className="justify-content-between">
            {contents.map((content, i) => (
              <Col lg={5} key={i}>
                <div className="kompetensi-card">
                  <div className="kompetensi-img">
                    <img src={content.image} alt={content.alt} loading="lazy" />
                  </div>
                  <div className="kompetensi-card-content">
                    <h3 className="sub-title">{t(content.title)}</h3>
                    <p className="description mt-10">{t(content.body)}</p>
                  </div>
                  <div className="kompetisi-card-btn">
                    <Button as={Link} to={content.link} className="main-btn">
                      {content.button}
                    </Button>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
          <Row className="kompetensi-quote mt-75 px-0">
            <Col className="text-center">
              <h5 className="description-section">{t("competenceDesc")}</h5>
            </Col>
          </Row>
        </Container>
      </div>
    </section>
  )
}
